module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "add button is-large is-warning",
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-medium"
  }, [_c('i', {
    class: _vm.iconClass
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b081427!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseActionRoundButton.vue
// module id = 319
// module chunks = 2